module.exports = __webpack_public_path__ + "static/media/desktopScreenshot08.710dbae0.jpg";